import Vuex from 'vuex'

import client from './core/client'
import city from './core/city'
import analytics from './core/analytics'
import goals from './goals'
import abtesting from './abtesting'
import order from './order'
import promocode from './promocode'
import invite from './invite'
import customizationInfo from './customizationInfo'
import vcp from './vcp'
import marketing from './marketing'
import modals from './animation/modals'
import appBar from './animation/appBar'
import firstScreenBtn from './animation/firstScreenBtn'
import signin from './signin'
import efst from './efst'
import templates from './templates'

export default new Vuex.Store({
  strict: true,
  modules: {
    abtesting,
    client,
    city,
    order,
    promocode,
    invite,
    goals,
    customizationInfo,
    vcp,
    analytics,
    marketing,
    modals,
    appBar,
    firstScreenBtn,
    efst,
    signin,
    templates,
  },
})
